import { ShieldCheck, IdCard, Crown, Sparkles, Award } from "lucide-react";

/**
 * Achievement badges for a user profile (server-computed in profile_badges).
 * Renders only badges the user has earned. Returns null when none.
 */
const BADGE_CONFIG = [
  {
    key: "super_host",
    label: "Super Host",
    icon: Crown,
    className: "bg-amber-50 text-amber-900 border-amber-200",
    iconClass: "text-amber-600",
    tooltip: "≥10 viajes · ≥4.8★ · <5% cancelación",
  },
  {
    key: "host_verificado",
    label: "Host Verificado",
    icon: ShieldCheck,
    className: "bg-blue-50 text-blue-900 border-blue-200",
    iconClass: "text-blue-600",
    tooltip: "Documentos de host aprobados",
  },
  {
    key: "usuario_verificado",
    label: "Usuario Verificado",
    icon: ShieldCheck,
    className: "bg-emerald-50 text-emerald-900 border-emerald-200",
    iconClass: "text-emerald-600",
    tooltip: "INE, licencia y selfie aprobados",
  },
  {
    key: "licencia_verificada",
    label: "Licencia Verificada",
    icon: IdCard,
    className: "bg-cyan-50 text-cyan-900 border-cyan-200",
    iconClass: "text-cyan-600",
    tooltip: "Licencia de conducir validada",
  },
  {
    key: "excelente_conductor",
    label: "Excelente Conductor",
    icon: Sparkles,
    className: "bg-violet-50 text-violet-900 border-violet-200",
    iconClass: "text-violet-600",
    tooltip: "≥5 viajes como huésped · ≥4.7★",
  },
];

export default function ProfileBadges({ badges, size = "md", testid = "profile-badges" }) {
  if (!badges) return null;
  const earned = BADGE_CONFIG.filter((b) => badges[b.key]);
  if (!earned.length) return null;

  const isSm = size === "sm";

  return (
    <div className="flex flex-wrap gap-2" data-testid={testid}>
      {earned.map(({ key, label, icon: Icon, className, iconClass, tooltip }) => (
        <span
          key={key}
          title={tooltip}
          data-testid={`badge-${key}`}
          className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${className} ${
            isSm ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-1 text-xs"
          }`}
        >
          <Icon className={`${isSm ? "w-3 h-3" : "w-3.5 h-3.5"} ${iconClass}`} />
          {label}
        </span>
      ))}
    </div>
  );
}

ProfileBadges.Award = Award; // re-export for convenience
